import * as orderTypes from '../types/orderTypes';
import { createOrder as createOrderRequest } from '../../services/orderService';

/** @param {Record<string, unknown>} orderData */
export const createOrder = (orderData) => async (dispatch) => {
  dispatch({ type: orderTypes.CREATE_ORDER_REQUEST });
  try {
    const response = await createOrderRequest(orderData);
    const orderPayload = response?.data ?? response;
    dispatch({
      type: orderTypes.CREATE_ORDER_SUCCESS,
      payload: orderPayload,
    });
    return { success: true, order: orderPayload };
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({
      type: orderTypes.CREATE_ORDER_FAILURE,
      payload: errorMessage,
    });
    return { success: false, error: errorMessage };
  }
};

export const clearOrderError = () => (dispatch) => {
  dispatch({ type: orderTypes.CLEAR_ORDER_ERROR });
};

export const clearOrderMessage = () => (dispatch) => {
  dispatch({ type: orderTypes.CLEAR_ORDER_MESSAGE });
};
